import { Component, input, output } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { IconModule } from '../icon/icon.module';
import { TagComponent } from '../tag/tag.component';
import { NgClass } from '@angular/common';
import { LinkTarget, Tags, TagType } from '@agilox/ui-common';

@Component({
	selector: 'ui-dashboard-box',
	templateUrl: './dashboard-box.component.html',
	imports: [ButtonComponent, IconModule, TagComponent, NgClass],
})
export class DashboardBoxComponent {
	type = input<'dark' | 'light'>('light');
	title = input<string>('');
	icon = input<string>('');
	image = input<string>('');
	buttonText = input<string>('');
	tagText = input<string>('');
	tagType = input<TagType>(Tags.PrimaryLight);
	tagIcon = input<string>('');
	styleClasses = input<string>('');
	href = input<string | undefined>(undefined);
	route = input<string | string[] | undefined>(undefined);
	target = input<LinkTarget | undefined>(undefined);

	buttonClicked = output<void>();

	emitClick() {
		this.buttonClicked.emit();
	}
}
